module.exports = __webpack_public_path__ + "static/img/ege.bd663e4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/index/ege.jpg
// module id = C8dS
// module chunks = 1